export const WIDGET_INTRO_KEYS = {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454417
     * */
    PLACEHOLDER: 'WIDGET_TYPE_INTRO',
};
